import {Observable} from 'rxjs';
import {educatAPI, RestQueryParams, IModelMentor} from 'educat-common-web';


export function getMyScholarsAPI(authToken: string | null, params?: typeof RestQueryParams): Observable<typeof IModelMentor> {
    let queryParams = params ? params : new RestQueryParams(),
        headers = undefined;
    if (authToken) {
        headers = {
            Authorization: `Bearer ${authToken}`,
        };
    }

    return educatAPI.get(
        `my_scholars`,
        queryParams,
        headers
    );
}
